/* =============================================
   SPORT SOLUTIONS — Theme JS v4
   ============================================= */

document.addEventListener('DOMContentLoaded', () => {

  // ---- MEGA MENU (Categorías) ----
  const catBtn      = document.getElementById('ss-cat-btn');
  const megaMenu    = document.getElementById('ss-cat-mega');
  const backdrop    = document.getElementById('ss-mega-backdrop');

  function openMega() {
    megaMenu?.classList.add('is-open');
    backdrop?.classList.add('is-open');
    catBtn?.setAttribute('aria-expanded', 'true');
    megaMenu?.setAttribute('aria-hidden', 'false');
  }
  function closeMega() {
    megaMenu?.classList.remove('is-open');
    backdrop?.classList.remove('is-open');
    catBtn?.setAttribute('aria-expanded', 'false');
    megaMenu?.setAttribute('aria-hidden', 'true');
  }

  catBtn?.addEventListener('click', (e) => {
    e.stopPropagation();
    cancelMegaClose();
    openMega();
  });
  const wideNav = window.matchMedia('(min-width: 1160px)');
  let megaCloseTimer;
  const cancelMegaClose = () => window.clearTimeout(megaCloseTimer);
  const scheduleMegaClose = () => {
    cancelMegaClose();
    megaCloseTimer = window.setTimeout(closeMega, 180);
  };
  catBtn?.addEventListener('pointerenter', () => { if (wideNav.matches) { cancelMegaClose(); openMega(); } });
  catBtn?.addEventListener('pointerleave', () => { if (wideNav.matches) scheduleMegaClose(); });
  megaMenu?.addEventListener('pointerenter', cancelMegaClose);
  megaMenu?.addEventListener('pointerleave', () => { if (wideNav.matches) scheduleMegaClose(); });
  megaMenu?.addEventListener('focusin', () => { cancelMegaClose(); openMega(); });
  megaMenu?.addEventListener('focusout', (e) => {
    if (!megaMenu.contains(e.relatedTarget) && e.relatedTarget !== catBtn) scheduleMegaClose();
  });
  backdrop?.addEventListener('click', closeMega);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeMega(); closeCartDrawer(); }
  });
  window.addEventListener('scroll', closeMega, { passive: true });

  // ---- MOBILE MENU ----
  const menuBtn    = document.getElementById('ss-menu-btn');
  const menuClose  = document.getElementById('ss-menu-close');
  const mobileMenu = document.getElementById('ss-mobile-menu');

  menuBtn?.addEventListener('click', () => { mobileMenu?.classList.add('is-open'); closeMega(); });
  menuClose?.addEventListener('click', () => mobileMenu?.classList.remove('is-open'));
  mobileMenu?.addEventListener('click', (e) => {
    if (e.target === mobileMenu) mobileMenu.classList.remove('is-open');
  });

  // ---- CAROUSELS ----
  document.querySelectorAll('[data-carousel]').forEach(wrapper => {
    const track   = wrapper.querySelector('[data-carousel-track]');
    const btnPrev = wrapper.querySelector('[data-carousel-prev]');
    const btnNext = wrapper.querySelector('[data-carousel-next]');
    if (!track) return;
    const getScrollAmount = () => {
      const item = track.querySelector('[data-carousel-item]');
      return item ? (item.offsetWidth + 16) * 2 : 560;
    };
    btnPrev?.addEventListener('click', () => track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' }));
    btnNext?.addEventListener('click', () => track.scrollBy({ left:  getScrollAmount(), behavior: 'smooth' }));
  });

  // ============================================================
  // CART DRAWER
  // ============================================================

  const drawer      = document.getElementById('ssc-drawer');
  const drawerBody  = document.getElementById('ssc-drawer-body');
  const drawerFoot  = document.getElementById('ssc-drawer-foot');
  const drawerCount = document.getElementById('ssc-drawer-count');
  const drawerClose = document.getElementById('ssc-drawer-close');
  const overlay     = document.getElementById('ssc-overlay');
  const subtotalEl  = document.getElementById('ssc-subtotal');

  function openCartDrawer() {
    drawer?.classList.add('is-open');
    overlay?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    renderCart();
  }

  function closeCartDrawer() {
    drawer?.classList.remove('is-open');
    overlay?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  drawerClose?.addEventListener('click', closeCartDrawer);
  overlay?.addEventListener('click', closeCartDrawer);

  // Cart icon in header → open drawer instead of navigate
  document.querySelectorAll('.ss-header__cart').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      openCartDrawer();
    });
  });

  // ---- Format money ----
  function formatMoney(cents) {
    const amount = cents / 100;
    return amount.toLocaleString('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 });
  }

  // ---- Update badge counters everywhere ----
  function updateBadges(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.classList.toggle('ss-cart-badge--hidden', count === 0);
    });
    if (drawerCount) drawerCount.textContent = count;
  }

  // ---- Render cart items inside drawer ----
  function renderCart() {
    if (!drawerBody) return;
    drawerBody.innerHTML = '<div class="ssc-loading"><div class="ssc-spinner"></div></div>';
    if (drawerFoot) drawerFoot.style.display = 'none';

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        updateBadges(cart.item_count);

        if (cart.item_count === 0) {
          drawerBody.innerHTML = `
            <div class="ssc-empty">
              <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2">
                <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
              </svg>
              <p class="ssc-empty__title">Tu carrito está vacío</p>
              <p class="ssc-empty__text">Agrega productos para comenzar</p>
              <a href="/collections/all" class="ssc-empty__btn" onclick="closeCartDrawer()">Ver productos</a>
            </div>`;
          if (drawerFoot) drawerFoot.style.display = 'none';
          return;
        }

        const itemsHTML = cart.items.map((item, idx) => {
          const imgSrc = item.image
            ? item.image.replace(/(\.\w+)(\?|$)/, '_80x80$1$2')
            : '';
          const variantLabel = item.variant_title && item.variant_title !== 'Default Title'
            ? `<div class="ssc-item__variant">${item.variant_title}</div>` : '';
          const vendorLabel = item.vendor
            ? `<div class="ssc-item__vendor">${item.vendor}</div>` : '';
          const linePrice = formatMoney(item.line_price);

          return `
            <div class="ssc-item" data-item-key="${item.key}">
              <div class="ssc-item__img-wrap">
                ${imgSrc
                  ? `<img class="ssc-item__img" src="${imgSrc}" alt="${item.product_title}" loading="lazy">`
                  : '<div class="ssc-item__img" style="background:#eee"></div>'}
              </div>
              <div class="ssc-item__body">
                ${vendorLabel}
                <div class="ssc-item__title">${item.product_title}</div>
                ${variantLabel}
                <div class="ssc-item__footer">
                  <div class="ssc-item__qty">
                    <button class="ssc-item__qty-btn" data-qty-change="-1" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Reducir">−</button>
                    <span class="ssc-item__qty-num">${item.quantity}</span>
                    <button class="ssc-item__qty-btn" data-qty-change="1" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Aumentar">+</button>
                  </div>
                  <span class="ssc-item__price">${linePrice}</span>
                  <button class="ssc-item__remove" data-remove="${item.key}" aria-label="Eliminar">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>`;
        }).join('');

        drawerBody.innerHTML = itemsHTML;

        if (drawerFoot) {
          drawerFoot.style.display = 'block';
          if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
        }
      })
      .catch(() => {
        drawerBody.innerHTML = '<div class="ssc-empty"><p class="ssc-empty__title">Error al cargar el carrito</p></div>';
      });
  }

  // ---- Quantity change & remove (delegated) ----
  drawerBody?.addEventListener('click', (e) => {
    // Quantity buttons
    const qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      const key    = qtyBtn.dataset.key;
      const delta  = parseInt(qtyBtn.dataset.qtyChange, 10);
      const newQty = parseInt(qtyBtn.dataset.qty, 10) + delta;
      changeCartItem(key, Math.max(0, newQty));
      return;
    }
    // Remove button
    const rmBtn = e.target.closest('[data-remove]');
    if (rmBtn) {
      changeCartItem(rmBtn.dataset.remove, 0);
    }
  });

  function changeCartItem(key, quantity) {
    if (!drawerBody) return;
    drawerBody.style.opacity = '0.5';
    drawerBody.style.pointerEvents = 'none';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    })
      .then(r => r.json())
      .then(cart => {
        drawerBody.style.opacity = '';
        drawerBody.style.pointerEvents = '';
        updateBadges(cart.item_count);
        renderCart();
      })
      .catch(() => {
        drawerBody.style.opacity = '';
        drawerBody.style.pointerEvents = '';
      });
  }

  // ---- Add to cart (centralised) ----
  function addToCart(items, btn) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    })
      .then(r => r.json())
      .then(data => {
        if (data.status) throw new Error(data.description || 'Error');
        return fetch('/cart.js').then(r => r.json());
      })
      .then(cart => {
        updateBadges(cart.item_count);
        return cart;
      });
  }

  // ---- QUICK ADD (product cards) ----
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const originalText = btn.textContent;
    btn.textContent = 'Agregando…';
    btn.disabled = true;

    addToCart([{ id: parseInt(variantId, 10), quantity: 1 }], btn)
      .then(() => {
        btn.textContent = '¡Agregado!';
        openCartDrawer();
        setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 2000);
      })
      .catch(() => { btn.textContent = 'Error'; btn.disabled = false; });
  });

  // ---- PRODUCT RACK — intercept ATC form ----
  document.querySelectorAll('[id^="bpr-atc-form-"]').forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const variantInput = form.querySelector('[name="id"]');
      const qtyInput     = form.querySelector('[name="quantity"]');
      const submitBtn    = form.querySelector('[type="submit"]');
      if (!variantInput) return;

      const variantId = parseInt(variantInput.value, 10);
      const qty       = parseInt(qtyInput?.value || '1', 10);
      const originalText = submitBtn?.textContent || 'Agregar al carrito';

      if (submitBtn) { submitBtn.textContent = 'Agregando…'; submitBtn.disabled = true; }

      addToCart([{ id: variantId, quantity: qty }])
        .then(() => {
          if (submitBtn) { submitBtn.textContent = '¡Agregado!'; }
          openCartDrawer();
          setTimeout(() => {
            if (submitBtn) { submitBtn.textContent = originalText; submitBtn.disabled = false; }
          }, 2000);
        })
        .catch(() => {
          if (submitBtn) { submitBtn.textContent = 'Error'; submitBtn.disabled = false; }
        });
    });
  });

  // ---- Initial cart count on load ----
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => updateBadges(cart.item_count))
    .catch(() => {});

  // ---- STICKY HEADER SHADOW ----
  const header = document.querySelector('.ss-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 10 ? '0 2px 20px rgba(0,0,0,0.5)' : 'none';
    }, { passive: true });
  }

  // expose closeCartDrawer globally for empty state link
  window.closeCartDrawer = closeCartDrawer;
});
